import React from 'react';

const base = {
  xmlns: 'http://www.w3.org/2000/svg',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.4,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  focusable: 'false',
  'aria-hidden': 'true',
};

export const ArrowRight = ({ size = 14, ...p }) => (
  <svg {...base} viewBox="0 0 24 24" width={size} height={size} className="arrow" {...p}>
    <path d="M4 12h15M13 6l6 6-6 6" />
  </svg>
);

export const ArrowDown = ({ size = 16, ...p }) => (
  <svg {...base} viewBox="0 0 24 24" width={size} height={size} {...p}>
    <path d="M12 4v15M6 13l6 6 6-6" />
  </svg>
);

export const Phone = ({ size = 16, ...p }) => (
  <svg {...base} viewBox="0 0 24 24" width={size} height={size} {...p}>
    <path d="M6.2 3.5h3l1.5 3.8-1.9 1.1a11.5 11.5 0 0 0 5.3 5.3l1.1-1.9 3.8 1.5v3a1.7 1.7 0 0 1-1.9 1.7A16.5 16.5 0 0 1 4.5 5.4 1.7 1.7 0 0 1 6.2 3.5Z" />
  </svg>
);

export const Pin = ({ size = 16, ...p }) => (
  <svg {...base} viewBox="0 0 24 24" width={size} height={size} {...p}>
    <path d="M12 21s7-5.3 7-11a7 7 0 1 0-14 0c0 5.7 7 11 7 11Z" />
    <circle cx="12" cy="10" r="2.6" />
  </svg>
);

export const Clock = ({ size = 16, ...p }) => (
  <svg {...base} viewBox="0 0 24 24" width={size} height={size} {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 7.5V12l3 1.8" />
  </svg>
);

export const Close = ({ size = 20, ...p }) => (
  <svg {...base} viewBox="0 0 24 24" width={size} height={size} {...p}>
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);

export const Check = ({ size = 18, ...p }) => (
  <svg {...base} viewBox="0 0 24 24" width={size} height={size} {...p}>
    <path d="M4.5 12.5l5 5 10-11" />
  </svg>
);

export const Bag = ({ size = 16, ...p }) => (
  <svg {...base} viewBox="0 0 24 24" width={size} height={size} {...p}>
    <path d="M5 8h14l-1 12H6L5 8Z" />
    <path d="M9 8V6.5a3 3 0 0 1 6 0V8" />
  </svg>
);

export const Instagram = ({ size = 18, ...p }) => (
  <svg {...base} viewBox="0 0 24 24" width={size} height={size} {...p}>
    <rect x="3.5" y="3.5" width="17" height="17" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.2" cy="6.8" r="0.9" fill="currentColor" stroke="none" />
  </svg>
);

export const XIcon = ({ size = 18, ...p }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    {...p}
  >
    <path d="M17.53 3H20.5l-6.49 7.42L21.6 21h-5.97l-4.68-6.11L5.6 21H2.63l6.94-7.94L2.4 3h6.12l4.23 5.59L17.53 3Zm-1.04 16.2h1.65L7.6 4.71H5.83l10.66 14.49Z" />
  </svg>
);

export const TikTok = ({ size = 18, ...p }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    {...p}
  >
    <path d="M16.2 2h-2.9v13.1a2.5 2.5 0 1 1-2.1-2.47v-2.95a5.4 5.4 0 1 0 5 5.38V8.6a6.4 6.4 0 0 0 3.8 1.23V6.9a3.55 3.55 0 0 1-3.8-3.6V2Z" />
  </svg>
);

export const SOCIAL_ICONS = { instagram: Instagram, x: XIcon, tiktok: TikTok };

/** The Local starburst, drawn as vectors so it scales and inherits colour. */
export const Starburst = ({ size = 56, spokes = 16, ...p }) => {
  const c = 50;
  const rays = Array.from({ length: spokes }, (_, i) => {
    const a = (i * 2 * Math.PI) / spokes;
    const long = i % 2 === 0 ? 38 : 27;
    const x1 = c + Math.cos(a) * 5;
    const y1 = c + Math.sin(a) * 5;
    const x2 = c + Math.cos(a) * long;
    const y2 = c + Math.sin(a) * long;
    return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} />;
  });
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      aria-hidden="true"
      focusable="false"
      {...p}
    >
      <circle cx="50" cy="50" r="46" strokeWidth="2" />
      {rays}
      <circle cx="50" cy="50" r="3" />
    </svg>
  );
};
